import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UserSuppliesRows } from '../UserSuppliesRows';
import { useUserSuppliesSectionStyle } from './UserSuppliesSection.style';
import { UserSuppliesEmpty } from '../UserSuppliesEmpty';
import { Store } from '../../../store';
import { UserSuppliesConnectWallet } from '../UserSuppliesConnectWallet';
import { getUsersSupplies } from '../../../store/supplies/actions';

export const UserSuppliesSection: FC = () => {
    const classes = useUserSuppliesSectionStyle();
    const dispatch = useDispatch();
    const { walletAddress, blockchainName, loading, items, hasUserSupplies, agreements } =
        useSelector((state: Store) => ({
            walletAddress: state.wallets.active.address,
            blockchainName: state.wallets.network,
            loading: state.supplies.userSuppliesLoading,
            items: state.supplies.userSupplies,
            hasUserSupplies: state.supplies.hasUserSupplies,
            agreements: state.agreements.agreements,
        }));

    useEffect(() => {
        dispatch(getUsersSupplies());
    }, [walletAddress, blockchainName, agreements]);

    const getContent = () => {
        if (!walletAddress) {
            return <UserSuppliesConnectWallet />;
        }

        const notLoading = !loading && !items.length;
        const userDontHaveSupplies = loading && !hasUserSupplies;
        if (notLoading || userDontHaveSupplies) {
            return <UserSuppliesEmpty />;
        }

        return (
            <div className={classes.tableWrapper}>
                <table className={classes.table}>
                    <thead>
                        <tr className={classes.tr}>
                            <th>Pool</th>
                            <th>Asset</th>
                            <th>Your Balance</th>
                            <th>APY</th>
                            <th>Interest Earned</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <UserSuppliesRows items={items} />
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className={classes.root}>
            <div className={classes.title}>Your Supplies</div>
            {getContent()}
        </div>
    );
};
